<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1 v-if="!form.id">ADD NEW VOTING SESSION</h1>
        <h1 v-else>EDIT VOTING SESSION</h1>
      </div>

      <div class="form-modal-body">
        <b-field label="Visibility" style="width: 100%">
          <b-select v-model="form.status" placeholder="Select a visibility" expanded>
            <option v-for="option in visibilities" :value="option.value" :key="option.value">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>

        <div class="row">
          <b-field label="Start Time" style="width: 100%">
            <b-datetimepicker v-model="dates.start_date.selected_date" placeholder="Click to select..."
              icon="calendar-today" :min-datetime="dates.start_date.min_date"
              :icon-right="dates.start_date.selected_date ? 'close-circle' : ''" icon-right-clickable
              @icon-right-click="clearStartDateTime" :locale="dates.start_date.locale"
              :first-day-of-week="dates.start_date.firstDayOfWeek"
              :datepicker="{ showWeekNumber: dates.start_date.showWeekNumber }" :timepicker="{
                enableSeconds: dates.start_date.enableSeconds,
                hourFormat: dates.start_date.hourFormat,
              }" horizontal-time-picker position="is-bottom-right">
            </b-datetimepicker>
          </b-field>
          <div class="h-spacer"></div>
          <b-field label="End Time" style="width: 100%">
            <b-datetimepicker v-model="dates.end_date.selected_date" :min-datetime="dates.start_date.selected_date"
              placeholder="Click to select..." icon="calendar-today"
              :icon-right="dates.end_date.selected_date ? 'close-circle' : ''" icon-right-clickable
              @icon-right-click="clearEndDateTime" :locale="dates.end_date.locale"
              :first-day-of-week="dates.end_date.firstDayOfWeek"
              :datepicker="{ showWeekNumber: dates.end_date.showWeekNumber }" :timepicker="{
                enableSeconds: dates.end_date.enableSeconds,
                hourFormat: dates.end_date.hourFormat,
              }" horizontal-time-picker position="is-bottom-left">
            </b-datetimepicker>
          </b-field>
        </div>

        <div class="row">
          <b-field label="Title" style="width: 100%">
            <b-input v-model="form.title"></b-input>
          </b-field>
        </div>

        <b-field label="Description">
          <b-input v-model="form.description" maxlength="1000" type="textarea"></b-input>
        </b-field>

        <div class="row">
          <b-field label="Sort Partipant by Votes" style="width: 100%">
            <b-switch v-model="form.sort_by_votes" type="is-primary"></b-switch>
          </b-field>
        </div>

        <div v-if="form.phase === 'voting'" class="row">
          <b-field label="Accept votes via payment (Mobile Money & USSD)" style="width: 100%">
            <b-switch v-model="form.accept_votes_via_payment" type="is-primary"></b-switch>
          </b-field>
          <p v-if="!form.accept_votes_via_payment" class="help is-info" style="width: 100%; margin-top: 4px;">
            When off, voters cast one free vote per device on the website. USSD and paid packages are disabled.
          </p>
        </div>

        <div class="row">
          <b-field label="Phase" style="width: 100%">
            <b-select v-model="form.phase" placeholder="Select a phase" expanded>
              <option v-for="option in phases" :value="option.value" :key="option.value">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div>

        <div v-if="form.phase === 'nomination'">
          <div class="row">
            <b-field label="Require Payment for Nominations" style="width: 100%">
              <b-switch v-model="form.nomination_requires_payment" type="is-primary"></b-switch>
            </b-field>
          </div>

          <div v-if="form.nomination_requires_payment" class="row">
            <b-field label="Nomination Fee (RWF)" style="width: 100%">
              <b-numberinput v-model="form.nomination_fee" min="0" step="100"></b-numberinput>
            </b-field>
          </div>

          <b-field label="Nomination Instructions">
            <b-input v-model="form.nomination_instructions" maxlength="2000" type="textarea"
              placeholder="Instructions for users on how to submit nominations"></b-input>
          </b-field>
        </div>

        <b-field label="Logo image">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.logo" @onFileSelected="(file) => {
              form.logo = file;
            }
            ">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>

        <b-field label="Cover image">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image" @onFileSelected="(file) => {
              form.image = file;
            }
            ">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>

        <!-- Intro Video Section -->
        <b-field label="Intro Video (YouTube URL)">
          <b-input v-model="form.intro_video" placeholder="https://www.youtube.com/watch?v=..."></b-input>
        </b-field>

        <!-- Rewards Section -->
        <div class="rewards-section">
          <div class="row">
            <b-field label="Enable Rewards" style="width: 100%">
              <b-switch v-model="form.rewards_enabled" type="is-primary"></b-switch>
            </b-field>
          </div>

          <div v-if="form.rewards_enabled">
            <div class="row">
              <b-field label="Reward Type" style="width: 100%">
                <b-select v-model="form.rewards_type" placeholder="Select reward type" expanded>
                  <option value="percentage">Percentage Based</option>
                  <option value="flat">Flat Fee Based</option>
                </b-select>
              </b-field>
            </div>

            <div v-if="form.rewards_type === 'percentage'">
              <div class="row">
                <b-field label="Enable reward deposit" style="width: 100%">
                  <b-switch v-model="form.reward_deposit_enabled" type="is-primary"></b-switch>
                </b-field>
                <p class="help is-info" style="width: 100%; margin-top: 4px;">
                  When enabled, participants receive a percentage of each paid vote as a deposit. When disabled,
                  the partner (channel owner) receives the full partner share from paid votes.
                </p>
              </div>
              <div v-if="form.reward_deposit_enabled" class="row">
                <b-field label="Reward Percentage (%)" style="width: 100%">
                  <b-numberinput v-model="form.rewards_fee" min="0" max="100" step="1"></b-numberinput>
                </b-field>
              </div>
            </div>

            <div v-if="form.rewards_type === 'flat'" class="rewards-plan-section">
              <h4>Rewards Plan</h4>
              <div v-for="(reward, index) in form.rewards_plan" :key="index" class="reward-item">
                <div class="row">
                  <b-field label="Votes Required" style="width: 30%; margin-right: 5%">
                    <b-numberinput v-model="reward.votes" min="0" step="1"></b-numberinput>
                  </b-field>
                  <b-field label="Reward Amount" style="width: 30%; margin-right: 5%">
                    <b-numberinput v-model="reward.reward" min="0" step="100"></b-numberinput>
                  </b-field>
                  <b-field label="Currency" style="width: 25%; margin-right: 5%">
                    <b-input v-model="reward.currency" placeholder="RWF"></b-input>
                  </b-field>
                  <b-button type="is-danger" size="is-small" @click="removeRewardPlan(index)"
                    style="margin-top: 8px;">Remove</b-button>
                </div>
              </div>
              <b-button type="is-primary" size="is-small" @click="addRewardPlan">Add Reward Plan</b-button>
            </div>
          </div>
        </div>

        <!-- Sponsors Section -->
        <div class="sponsors-section">
          <h4>Sponsors</h4>
          <div v-for="(sponsor, index) in form.sponsors" :key="index" class="sponsor-item">
            <div class="row">
              <b-field label="Logo Image" style="width: 35%; margin-right: 5%">
                <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                  location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
                  :uploadurl="$store.state.BASE_URL + 'upload'" name="sponsor-logo" :value="sponsor.logo"
                  @onFileSelected="(file) => {
                    sponsor.logo = file;
                  }">
                  <div class="image-upload-widget-small">Choose Logo</div>
                </upload-trigger>
              </b-field>
              <b-field label="Website Link" style="width: 45%; margin-right: 5%">
                <b-input v-model="sponsor.link" placeholder="https://example.com"></b-input>
              </b-field>
              <b-button type="is-danger" size="is-small" @click="removeSponsor(index)"
                style="margin-top: 8px;">Remove</b-button>
            </div>
          </div>
          <b-button type="is-primary" size="is-small" @click="addSponsor">Add Sponsor</b-button>
        </div>
      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    channel: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    dates: {
      start_date: {
        selected_date: new Date(),
        min_date: new Date(),
        showWeekNumber: false,
        enableSeconds: false,
        hourFormat: undefined, // Browser locale
        locale: undefined, // Browser locale
        firstDayOfWeek: undefined, // 0 - Sundays
      },
      end_date: {
        selected_date: new Date(),
        showWeekNumber: false,
        enableSeconds: false,
        hourFormat: undefined, // Browser locale
        locale: undefined, // Browser locale
        firstDayOfWeek: undefined, // 0 - Sunday
      },
    },
    visibilities: [
      {
        value: "public",
        name: "Public",
      },
      {
        value: "unlisted",
        name: "Unlisted",
      },
    ],
    phases: [
      {
        value: "nomination",
        name: "Nomination Phase",
      },
      {
        value: "voting",
        name: "Voting Phase",
      },
    ],
    form: {
      id: null,
      channel_id: null,
      start_date: "",
      end_date: "",
      title: "",
      description: "",
      sort_by_votes: false,
      logo: "",
      image: "",
      status: "unlisted",
      phase: "voting",
      accept_votes_via_payment: true,
      nomination_requires_payment: false,
      nomination_fee: 0,
      nomination_instructions: "",
      intro_video: "",
      rewards_enabled: false,
      rewards_type: "percentage",
      rewards_fee: 0,
      reward_deposit_enabled: true,
      rewards_plan: [],
      sponsors: [],
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    setFormFields() {
      let vm = this;
      vm.form.id = vm.value.id;
      vm.form.channel_id = vm.value.channel_id;
      vm.form.start_date = vm.value.start_time;
      vm.form.end_date = vm.value.end_time;
      vm.dates.start_date.selected_date = vm.value.start_time
        ? vm.moment(vm.value.start_time).toDate()
        : null;
      vm.dates.end_date.selected_date = vm.value.end_time
        ? vm.moment(vm.value.end_time).toDate()
        : null;
      vm.form.title = vm.value.title;
      vm.form.description = vm.value.description;
      vm.form.sort_by_votes = vm.value.sort_by_votes == 1 ? true : false;
      vm.form.image = vm.value.cover_image;
      vm.form.logo = vm.value.logo;
      vm.form.status = vm.value.status;
      vm.form.phase = vm.value.phase || "voting";
      vm.form.accept_votes_via_payment =
        vm.value.accept_votes_via_payment === undefined ||
        vm.value.accept_votes_via_payment === null
          ? true
          : vm.value.accept_votes_via_payment == 1;
      vm.form.nomination_requires_payment = vm.value.nomination_requires_payment == 1 ? true : false;
      vm.form.nomination_fee = vm.value.nomination_fee || 0;
      vm.form.nomination_instructions = vm.value.nomination_instructions || "";
      vm.form.intro_video = vm.value.intro_video || "";
      vm.form.rewards_enabled = vm.value.rewards_enabled == 1 ? true : false;
      vm.form.rewards_type = vm.value.rewards_type || "percentage";
      vm.form.rewards_fee = vm.value.rewards_fee || 0;
      vm.form.reward_deposit_enabled =
        vm.value.reward_deposit_enabled === undefined ||
        vm.value.reward_deposit_enabled === null
          ? true
          : vm.value.reward_deposit_enabled == 1;
      vm.form.rewards_plan = vm.value.rewards_plan ? JSON.parse(vm.value.rewards_plan) : [];
      vm.form.sponsors = vm.value.sponsors ? JSON.parse(vm.value.sponsors) : [];
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        channel_id: null,
        start_date: "",
        end_date: "",
        title: "",
        description: "",
        sort_by_votes: false,
        image: "",
        status: "unlisted",
        logo: "",
        phase: "voting",
        accept_votes_via_payment: true,
        nomination_requires_payment: false,
        nomination_fee: 0,
        nomination_instructions: "",
        intro_video: "",
        rewards_enabled: false,
        rewards_type: "percentage",
        rewards_fee: 0,
        reward_deposit_enabled: true,
        rewards_plan: [],
        sponsors: [],
      };
    },
    clearStartDateTime() {
      let vm = this;
      vm.dates.start_date.selected_date = null;
    },
    clearEndDateTime() {
      let vm = this;
      vm.dates.end_date.selected_date = null;
    },
    submitForm() {
      let vm = this;
      // Start validate
      const rules = {
        start_date: {
          run: (value) => {
            if (!vm.dates.start_date.selected_date) {
              return "Start date is required";
            }
            return false;
          },
        },
        end_date: {
          run: (value) => {
            if (!vm.dates.end_date.selected_date) {
              return "End date is required";
            }
            return false;
          },
        },
        title: {
          run: (value) => {
            if (!value) {
              return "Title can not be empty";
            }
            return false;
          },
        },
        description: {
          run: (value) => {
            if (!value) {
              return "Description can not be empty";
            }
            return false;
          },
        },
        logo: {
          run: (value) => {
            if (!value) {
              return "Please upload a logo image";
            }
            return false;
          },
        },
        image: {
          run: (value) => {
            if (!value) {
              return "Please upload a cover image";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        vm.form.channel_id = vm.channel.id;
        vm.form.start_date = vm
          .moment(vm.dates.start_date.selected_date)
          .format("YYYY-MM-DD HH:mm:ss");
        vm.form.end_date = vm
          .moment(vm.dates.end_date.selected_date)
          .format("YYYY-MM-DD HH:mm:ss");
        if (!vm.form.id) {
          vm.$store
            .dispatch("VOTING_ADDNEW_VOTING_SESSION", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("saved", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        } else {
          vm.$store
            .dispatch("VOTING_UPDATE_VOTING_SESSION", vm.form)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("saved", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
    addRewardPlan() {
      this.form.rewards_plan.push({
        votes: 0,
        reward: 0,
        currency: "RWF"
      });
    },
    removeRewardPlan(index) {
      this.form.rewards_plan.splice(index, 1);
    },
    addSponsor() {
      this.form.sponsors.push({
        logo: "",
        link: ""
      });
    },
    removeSponsor(index) {
      this.form.sponsors.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 900px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 950px) {
    width: 95% !important;
  }

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
      align-items: stretch !important;

      .field {
        width: 100% !important;
        margin-right: 0 !important;
      }
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;

    .row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 15px;
    }

    .rewards-section {
      background: #f8f9fa;
      padding: 15px;
      border-radius: 8px;
      margin: 20px 0;

      h4 {
        margin-bottom: 15px;
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }

      .rewards-plan-section {
        background: #ffffff;
        padding: 15px;
        border-radius: 6px;
        margin-top: 10px;

        .reward-item {
          background: #f9f9f9;
          padding: 10px;
          border-radius: 4px;
          margin-bottom: 10px;
        }
      }
    }

    .sponsors-section {
      background: #f8f9fa;
      padding: 15px;
      border-radius: 8px;
      margin: 20px 0;

      h4 {
        margin-bottom: 15px;
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }

      .sponsor-item {
        background: #ffffff;
        padding: 10px;
        border-radius: 4px;
        margin-bottom: 10px;
      }
    }

    .image-upload-widget {
      padding: 20px;
      border: 2px dashed #ddd;
      border-radius: 8px;
      text-align: center;
      cursor: pointer;
      background: #f8f9fa;
      transition: all 0.3s ease;

      &:hover {
        border-color: #3273dc;
        background: #f0f8ff;
      }
    }

    .image-upload-widget-small {
      padding: 10px;
      border: 2px dashed #ddd;
      border-radius: 6px;
      text-align: center;
      cursor: pointer;
      background: #f8f9fa;
      font-size: 12px;
      transition: all 0.3s ease;

      &:hover {
        border-color: #3273dc;
        background: #f0f8ff;
      }
    }
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 1100px) {
      width: 700px;
    }

    @media (max-width: 846px) {
      width: 600px;
    }

    @media (max-width: 768px) {
      width: 95%;
    }
  }
}
</style>
